export const calculateMeslekiEgilim = (answers) => {
  const groups = { A: 0, B: 0, C: 0, D: 0, E: 0, F: 0, G: 0, H: 0, I: 0, 'İ': 0 };

const CAREER_GROUPS = {
  A: "Doğa ve Tarım",
  B: "Mekanik ve Teknoloji",
  C: "Liderlik ve Yönetim",
  D: "Sanat ve Medya",
  E: "Edebiyat ve İletişim",
  F: "Sosyal Bilimler",
  G: "Uluslararası İlişkiler",
  H: "Tıp ve Sağlık",
  I: "Finans ve Analiz",
  "İ": "Yazılım ve Bilişim"
};
  
  // 1'den 160'a kadar olan soruları modüler (bölümünden kalan) matematikle 10 sütuna dağıtıyoruz
  const getGroup = (qId) => {
      const mod = qId % 10;
      if (mod === 1) return 'A';
      if (mod === 2) return 'B';
      if (mod === 3) return 'C';
      if (mod === 4) return 'D';
      if (mod === 5) return 'E';
      if (mod === 6) return 'F';
      if (mod === 7) return 'G';
      if (mod === 8) return 'H';
      if (mod === 9) return 'I';
      if (mod === 0) return 'İ';
      return null;
  };

  if (answers) {
    Object.keys(answers).forEach(qId => {
        const group = getGroup(parseInt(qId));
        if (group && parseInt(answers[qId]) === 1) {
            groups[group] += 10; // Her "Bana Uygun" cevabı 10 puan kazandırır
        }
    });
  }

  // PDF'teki resmi yorumlama baremleri
  const getInterpretation = (score) => {
    if (score >= 131) return "Çok Belirgin Eğilim";
    if (score >= 101) return "Belirgin Eğilim";
    if (score >= 81) return "Orta Düzey Eğilim";
    if (score >= 41) return "Daha Az Belirgin Eğilim";
    return "Belirgin Eğilim Gözlenmedi";
};

  const detailedScores = Object.keys(groups).map(key => ({
      groupKey: key,
      score: groups[key],
      interpretation: getInterpretation(groups[key])
  }));

const sortedScores = [...detailedScores]
  .sort((a, b) => b.score - a.score);

const top3 = sortedScores
  .filter(item => item.score > 0)
  .slice(0, 3);

const top1 = top3[0] || null;


const STUDENT_FEEDBACK_MAP = {

  A: {
    headline: "Doğa ve Tarım Alanı Öne Çıkıyor",
    message:
      "Doğa, canlılar, çevre ve sürdürülebilir yaşamla ilgili çalışmalar sana daha yakın gelebilir. Üretim, çevre sorunları ve doğal sistemlerle ilgilenen meslek alanlarını keşfetmek senin için iyi bir başlangıç olabilir."
  },

  B: {
    headline: "Mekanik ve Teknoloji Alanı Öne Çıkıyor",
    message:
      "Bir şeylerin nasıl çalıştığını anlamak, tasarlamak, üretmek ve teknik problemleri çözmek sana çekici gelebilir. Mühendislik, mimarlık, tasarım ve teknolojiyle ilişkili alanları daha yakından inceleyebilirsin."
  },

  C: {
    headline: "Liderlik ve Yönetim Alanı Öne Çıkıyor",
    message:
      "Sorumluluk almak, karar vermek, insanları organize etmek ve bir hedef doğrultusunda ilerlemek sana yakın olabilir. Yönetim, hukuk, girişimcilik ve organizasyon gerektiren alanları keşfetmek ilgini çekebilir."
  },

  D: {
    headline: "Sanat ve Medya Alanı Öne Çıkıyor",
    message:
      "Kendini yaratıcı yollarla ifade etmek, yeni içerikler üretmek, tasarlamak ve ortaya özgün işler koymak sana yakın olabilir. Sanat, medya, tasarım ve yaratıcı üretim alanlarını keşfedebilirsin."
  },

  E: {
    headline: "Edebiyat ve İletişim Alanı Öne Çıkıyor",
    message:
      "Düşüncelerini sözlü veya yazılı biçimde ifade etmek, insanlarla iletişim kurmak ve anlatmak sana yakın olabilir. Dil, edebiyat, iletişim, danışmanlık ve insan ilişkileri içeren alanları inceleyebilirsin."
  },

  F: {
    headline: "Sosyal Bilimler Alanı Öne Çıkıyor",
    message:
      "İnsan davranışlarını, toplumları ve geçmişten bugüne yaşanan değişimleri anlamaya yönelik konular ilgini çekiyor olabilir. Psikoloji, sosyoloji, tarih ve diğer sosyal bilim alanlarını keşfetmek sana yeni fikirler verebilir."
  },

  G: {
    headline: "Uluslararası Alanlar Öne Çıkıyor",
    message:
      "Farklı ülkeler, kültürler, diller ve dünyadaki gelişmeler ilgini çekiyor olabilir. Uluslararası ilişkiler, diplomasi ve farklı kültürlerle iletişim içeren alanları araştırabilirsin."
  },

  H: {
    headline: "Tıp ve Sağlık Alanı Öne Çıkıyor",
    message:
      "İnsan sağlığı, biyoloji ve insanların yaşam kalitesini desteklemeye yönelik çalışmalar sana yakın gelebilir. Sağlık bilimleriyle ilişkili farklı meslekleri ve bu alanların eğitim süreçlerini araştırabilirsin."
  },

  I: {
    headline: "Finans ve Analiz Alanı Öne Çıkıyor",
    message:
      "Verilerle düşünmek, ekonomik olayları anlamak, hesaplama yapmak ve sonuçları analiz etmek sana çekici gelebilir. Ekonomi, finans, işletme ve analiz ağırlıklı alanları keşfedebilirsin."
  },

  "İ": {
    headline: "Yazılım ve Bilişim Alanı Öne Çıkıyor",
    message:
      "Teknoloji üretmek, bilgisayarlarla çalışmak, sistemlerin mantığını çözmek ve dijital problemler için yeni çözümler geliştirmek sana yakın olabilir. Yazılım, bilgisayar ve bilişim alanlarını daha yakından inceleyebilirsin."
  }

};


const dominantFeedback =
  top1 ? STUDENT_FEEDBACK_MAP[top1.groupKey] : null;


const studentFeedback = {
  eyebrow: "MESLEKİ YÖNELİM PROFİLİN",

  title: "Sana Yakın Görünen Alanlar",

  headline:
    dominantFeedback?.headline ||
    "Mesleki Eğilimlerin Henüz Belirginleşiyor",

  highlights: top3.map(item =>
    CAREER_GROUPS[item.groupKey] || item.groupKey
  ),

  message:
    dominantFeedback?.message ||
    "Yanıtlarında belirgin biçimde öne çıkan tek bir mesleki alan görünmüyor. Bu durum bir sorun değildir; farklı meslekleri, dersleri ve çalışma ortamlarını deneyimledikçe ilgilerin daha fazla belirginleşebilir.",

  counselorNote:
    "Bu sonuç tek başına hangi mesleği seçmen gerektiğini göstermez. Mesleki kararlarını ilgi alanların, değerlerin, yeteneklerin, akademik özelliklerin ve eğitim seçeneklerinle birlikte psikolojik danışmanınla değerlendirmen daha sağlıklı olur.",

  btnText: "Alanlarımı Gördüm"
};

 return {
    riskScore: sortedScores[0]?.score || 0,
    masterRisk: "none",
    riskLevel: "none",
    isCritical: false,
    domain: "profile",

    summary: top1
      ? `Öne Çıkan Mesleki Alan: ${CAREER_GROUPS[top1.groupKey]}`
      : "Mesleki eğilim profili henüz belirgin değil.",

    scores: groups,
    detailedScores: detailedScores,

    // 🌟 Öğrenci test sonrası kişisel geri bildirimi
    studentFeedback: studentFeedback,

    risks: [],
    colorCode: "teal"
};
};